import { createIcon } from '@chakra-ui/react';

export const MTSIcon = createIcon({
  displayName: 'MTSIcon',
  viewBox: '0 0 44 44',
  path: (
    <>
      <g clipPath='url(#clip0_943_259651)'>
        <path d='M44 0H0V44H44V0Z' fill='#FF0032' />
        <path
          d='M29.312 3.3839V5.40886H33.7399V13.5357H36.2149V5.40886H40.6338V3.3839H29.312Z'
          fill='white'
        />
        <path
          d='M13.3916 3.3839L10.1516 10.0978L6.92071 3.3839H3.38379V13.5357H5.86773V6.27284L9.02666 12.4107H11.2856L14.4445 6.27284V13.5357H16.9195V3.3839H13.3916Z'
          fill='white'
        />
        <path
          d='M38.1586 37.2321C38.0956 37.6371 37.9336 37.9701 37.6726 38.2221C37.4296 38.4561 37.0966 38.6271 36.6826 38.7261C36.2776 38.8161 35.6747 38.8701 35.0447 38.8701C34.3877 38.8701 33.8117 38.7891 33.3167 38.6181C32.8397 38.4561 32.4617 38.1681 32.2007 37.7721C31.9307 37.3761 31.7957 36.8002 31.7957 36.0532V35.0182C31.7957 34.2802 31.9307 33.7042 32.2007 33.2992C32.4707 32.9032 32.8397 32.6153 33.3167 32.4533C33.8027 32.2823 34.3877 32.2013 35.0447 32.2013C35.6747 32.2013 36.2776 32.2553 36.6826 32.3453C37.0966 32.4443 37.4296 32.6062 37.6726 32.8492C37.9336 33.1012 38.0956 33.4342 38.1586 33.8392H40.6335C40.5615 33.0022 40.2826 32.2913 39.7876 31.7153C39.3376 31.1933 38.7076 30.8153 37.9246 30.5813C37.1686 30.3563 36.1696 30.2393 35.0447 30.2393C33.8567 30.2393 32.8307 30.4103 31.9847 30.7433C31.1298 31.0853 30.4638 31.6523 30.0048 32.4353C29.5638 33.1822 29.3388 34.1902 29.3208 35.4142V35.5312L29.4558 35.5402L29.3208 35.5492V35.5582V35.6662C29.3388 36.8902 29.5638 37.8981 30.0048 38.6451C30.4638 39.4281 31.1298 39.9951 31.9847 40.3371C32.8307 40.6701 33.8567 40.8411 35.0447 40.8411C36.1696 40.8411 37.1686 40.7241 37.9246 40.4991C38.7076 40.2651 39.3286 39.8871 39.7876 39.3651C40.2826 38.7981 40.5705 38.0781 40.6335 37.2411H38.1586V37.2321Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_943_259651'>
          <rect width='44' height='44' fill='white' />
        </clipPath>
      </defs>
    </>
  ),
});
